import styles from './ExtractionStats.module.css';

export interface ExtractionStatsProps {
  /** `short` stands in for `label` on a phone, where every stat shares one row. */
  stats: { label: string; short?: string; value: string | number }[];
}

export function ExtractionStats({ stats }: ExtractionStatsProps) {
  return (
    <dl className={styles.stats}>
      {stats.map((stat) => (
        <div key={stat.label} className={styles.stat}>
          <dt>
            <span className={styles.long}>{stat.label}</span>
            <span className={styles.short}>{stat.short ?? stat.label}</span>
          </dt>
          <dd>{stat.value}</dd>
        </div>
      ))}
    </dl>
  );
}
